import { Component } from '@angular/core';

@Component({
    selector: 'pim-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.sass'],
    standalone: false
})
export class LoaderComponent {
}
